import _extends from 'babel-runtime/helpers/extends';

import DynamicForm from '@/components/DynamicForm'; // 动态表单组件

export default {
  components: {
    DynamicForm: DynamicForm
  },

  props: {
    dialogConfig: {
      type: Object,
      default: function _default() {}
    },
    formConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    formValue: {
      type: Object,
      required: true
    }
  },

  computed: {
    innerFormConfig: function innerFormConfig() {
      return _extends({
        labelPosition: 'top',
        labelWidth: ''
      }, this.formConfig);
    },
    formItemList: function formItemList() {
      return [{
        label: '需求名称：',
        type: 'plain-text',
        prop: 'name'
      }, {
        label: '需求说明：',
        type: 'plain-text',
        prop: 'instruction'
      }, {
        label: '需求类型：',
        type: 'plain-text',
        prop: 'type'
      }, {
        visible: this.formValue.edit_dev === 0,
        label: '是否需要研发',
        prop: 'no_dev',
        type: 'radio-group',
        rules: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (value === null || value === undefined || value === 0) {
              callback(new Error('请选择是否需要研发介入'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        params: {
          options: [{
            label: '需要',
            value: 2
          }, {
            label: '不需要',
            value: 1
          }],
          placeholder: '请选择',
          filterable: true,
          clearable: true
        }
      }, {
        // 数据原本no_dev = 1、2，那直接展示, 如果数据原本no_dev=0，那根据‘是否需要研发’选项控制显示隐藏，formValue.no_dev = 2时显示 其他情况隐藏；
        visible: this.formValue.no_dev === 2 || this.formValue.edit_dev !== 0,
        label: '指定研发：',
        type: 'business',
        subtype: 'developer-selector',
        prop: 'developer_id',
        rules: [{
          required: true,
          message: '请分配研发人员',
          trigger: 'change'
        }],
        params: {
          filterable: true
        }
      }];
    }
  },

  watch: {
    'dialogConfig.visible': function dialogConfigVisible(val) {
      var _this = this;

      if (val && this.$refs.form) {
        setTimeout(function () {
          _this.clearValidate();
        });
      }
    }
  },

  methods: {
    submitDialog: function submitDialog() {
      var _this2 = this;

      this.validate().then(function () {
        _this2.$emit('submit', _this2.formValue);
      });
    },
    handleClose: function handleClose(done) {
      if (this.dialogConfig.loading) {
        return false;
      }
      return done();
    },
    clearValidate: function clearValidate() {
      return this.$refs.form.clearValidate();
    },
    validate: function validate() {
      var _$refs$form;

      return (_$refs$form = this.$refs.form).validate.apply(_$refs$form, arguments);
    }
  }
};